import { Component } from '@angular/core';

@Component({
  selector: 'app-process-follow',
  templateUrl: './process-follow.component.html',
  styleUrls: ['./process-follow.component.css']
})
export class ProcessFollowComponent {

}
